import React, { useState, useEffect, useCallback } from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  Box,
  IconButton,
  Tooltip,
  Button,
  Avatar,
  Accordion,
  AccordionDetails,
} from "@mui/material";
import moment from "moment";
import "./Report.css";
import InfoIcon from "@mui/icons-material/Info";
import eyeIcon from "../../icons/eye.svg";
import ImageView from "./ImageView";
import EmpWisTable from "./EmpWiseReportExcel";
import { Base64 } from "js-base64";
import UseModal from "../Modal/Modal";
import { v4 } from "uuid";
import ViewDefaultMeetingDialog from "./ViewDefaultMeetingDialog";

const colorArray = ["#FFFF", "#F9F9D9"];

const SummaryReport = (props) => {
  const {
    communicationDetails,
    filterCommunicationDetails,
    setCommunicationDetails,
    clientIdCommunicationData,
    clientIdCommunicationDataHeader,
    communicationDetailsDynamiceHeader,
    configurationName,
  } = props;
  const localData = JSON.parse(localStorage.getItem("data")) || {};

  // let companyToken="This Is a CAR"
  const [filters, setFilters] = useState({
    employee: "",
    vendor: "",
    contactperson: "",
    contactno: "",
    communicationmode: "All",
    relationshiptype: "All",
  });

  console.log(
    "clientIdCommunicationDataHeader : ",
    clientIdCommunicationDataHeader,
  );

  var base64regex =
    /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
  // console.log(base64regex.test("8J+YgvCfmIU="));
  // console.log(atob("8J+YgvCfmIU="))           // FALSE
  // base64regex.test("U29tZVN0cmluZ09idmlvdXNseU5vdEJhc2U2NEVuY29kZWQ=");

  const {
    employee,
    vendor,
    contactperson,
    contactno,
    communicationmode,
    relationshiptype,
  } = filters;
  const [ImgUrl, setImgUrl] = useState();
  const [OpenViewImageModal, setOpenViewImageModal] = useState(false);
  const [defaultMeetingModal, setDefaultMeetingModal] = useState({
    data: null,
    open: false,
  });
  // const clintDataRow = clientIdCommunicationData.map((ele, index) => {
  //   return <TableRow></TableRow>;
  // });

  // const handleSorting = () => {
  //   const communicationDetailsToSet = communicationDetails.map((item) => ({
  //     ...item,
  //     currentDate: item.communicationDetails.sort((first, second) => {

  //       if (moment(first.createDate).isSame(second.createDate)) {
  //         return 1;
  //       } else if (moment(first.createDate).isAfter(second.createDate)) {
  //         return -1;
  //       } else {
  //         return -1;
  //       }
  //     }),
  //   }));

  //   setCommunicationDetails(communicationDetailsToSet);
  // };
  const handleView = useCallback((id, date, odId) => {
    let newdate = new Date(date);
    const obj = {
      // hrmsUserId: JSON.parse(localStorage.getItem("data")).hrmsUserId,
      userId: id,
      filterUserId: id,
      fromDate: moment(newdate).format("YYYY-MM-DD"),
      toDate: moment(newdate).format("YYYY-MM-DD"),
      id: odId,
      // fromDate: fromDate,
      // toDate: toDate,
    };
    localStorage.setItem("singleDetail", JSON.stringify(obj));
    // navigate("/details");
    window.open(`/details/${id}`, "_blank");
  }, []);

  let currentColor = colorArray[0];

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFilters({ ...filters, [name]: value });
  // };

  const handleFilter = () => {
    let filterValueToSet = filterCommunicationDetails;
    if (employee) {
      const input1 = employee;
      filterValueToSet = filterValueToSet
        .map((item) => ({
          ...item,
          communicationDetails: item.communicationDetails.filter((child) =>
            child.userName.toLowerCase().includes(input1.toLowerCase()),
          ),
        }))
        .filter((item) => item.communicationDetails.length > 0);
    }
    if (vendor) {
      const input2 = vendor;
      filterValueToSet = filterValueToSet
        .map((item) => ({
          ...item,
          communicationDetails: item.communicationDetails.filter((child) =>
            child.clientName.toLowerCase().includes(input2.toLowerCase()),
          ),
        }))
        .filter((item) => item.communicationDetails.length > 0);
    }
    if (contactperson) {
      const input = contactperson;
      filterValueToSet = filterValueToSet
        .map((item) => ({
          ...item,
          communicationDetails: item.communicationDetails.filter((child) =>
            child.contactPerson.toLowerCase().includes(input.toLowerCase()),
          ),
        }))
        .filter((item) => item.communicationDetails.length > 0);
    }
    if (contactno) {
      const input = contactno;
      filterValueToSet = filterValueToSet
        .map((item) => ({
          ...item,
          communicationDetails: item.communicationDetails.filter((child) =>
            child.contactPersonNo.toLowerCase().includes(input.toLowerCase()),
          ),
        }))
        .filter((item) => item.communicationDetails.length > 0);
    }
    if (communicationmode !== "All") {
      const targetValue = communicationmode;
      filterValueToSet = filterValueToSet
        .map((item) => ({
          ...item,
          communicationDetails: item.communicationDetails.filter((child) =>
            child.mode.toLowerCase().includes(targetValue.toLowerCase()),
          ),
        }))
        .filter((item) => item.communicationDetails.length > 0);
    }
    if (relationshiptype !== "All") {
      if (relationshiptype === "New Client") {
        filterValueToSet = filterValueToSet
          .map((item) => ({
            ...item,
            communicationDetails: item.communicationDetails.filter(
              (child) => child.isNewClient === true,
            ),
          }))
          .filter((item) => item.communicationDetails.length > 0);
      } else if (relationshiptype === "Existing Client") {
        filterValueToSet = filterValueToSet
          .map((item) => ({
            ...item,
            communicationDetails: item.communicationDetails.filter(
              (child) => child.isNewClient === false,
            ),
          }))
          .filter((item) => item.communicationDetails.length > 0);
      } else if (relationshiptype === "New Vendor") {
        filterValueToSet = "";
      }
    }
    setCommunicationDetails(filterValueToSet);
  };
  // const exportHandler = () => {};

  // const rediretcfetchdata = () => {
  //   const Schedule = JSON.parse(localStorage.getItem("ScheduledData"));
  //   if (JSON.parse(localStorage.getItem("ScheduledData"))) {

  //   }
  // document.getElementById("Reportsbtn").click();
  // };

  // useEffect(() => {
  //   rediretcfetchdata();
  //localStorage.removeItem("ScheduledData");
  //document.getElementById("Reportsbtn").click();
  // }, [JSON.parse(localStorage.getItem("ScheduledData"))]);

  useEffect(() => {
    handleFilter();
  }, [filters]);

  let clientIdCommunicationDataArray =
    clientIdCommunicationData &&
    clientIdCommunicationData !== undefined &&
    clientIdCommunicationData.length !== 0
      ? communicationDetails.slice(0, 1)
      : communicationDetails;

  const openmodalhalndlerBysingle = useCallback((data) => {
    console.log(data, "ghfgeyrgfrferbh");
    debugger;
    localStorage.setItem(
      "ExpencesData",
      JSON.stringify({
        communicationIds: [data ? data.id : null],
        odDailyDistanceIds: null,
        from: data && data.createdDateTime,
        to: data && data.createdDateTime,
        Status: null,
      }),
    );

    //data.clientCommunicationDtoList[0].createdDateTime,

    window.open("/expenseList", "_blanck");
  }, []);
  const viewImageRidarect = useCallback((data) => {
    console.log(
      data,

      "viewImageRidarect",
    );
    let imgUrlList = data && data !== undefined && data.split(",");
    console.log(imgUrlList, "imgUrlList");
    setImgUrl(imgUrlList);
    setOpenViewImageModal(true);
  }, []);

  const openmodalhalndler = useCallback((type, data) => {
    let arryaIds = data?.clientCommunicationDtoList?.map(
      (communication) => communication.id,
    );

    localStorage.setItem(
      "ExpencesData",
      JSON.stringify({
        communicationIds: arryaIds ? arryaIds : [],
        odDailyDistanceIds: data ? data.id : null,
        from: data.createdDate ? data.createdDate : null,
        to: data.createdDate ? data.createdDate : null,
        Status: type ? (type !== "Total" ? type : null) : null,
      }),
    );
    window.open("/expenseList", "_blanck");
    //setExpencesData(data);
    //setopenExpenseModal(true);
  }, []);
  // const exportHandler1 = (item) => {

  //   if (item && item) {
  //     setTimeout(() => {
  //       document.getElementById("imployeWiseTable1").click();

  //     }, 500);
  //   }
  // };
  const OpenImageDirectTopage = useCallback((url) => {
    window.open(url);
  }, []);

  const TotalDistance =
    communicationDetails &&
    communicationDetails.reduce(
      (accumulator, currentValue) =>
        Number(accumulator ? accumulator : 0) +
        Number(currentValue.totalDistance ? currentValue.totalDistance : 0),
      0,
    );

  console.log(communicationDetails);

  const handleViewDefaultMeeting = useCallback((curelem) => {
    console.log(curelem);
    setDefaultMeetingModal({
      data: curelem,
      open: true,
    });
  }, []);

  const handleCloseDefaultMeetingModal = useCallback(() => {
    setDefaultMeetingModal({
      data: null,
      open: false,
    });
  }, []);

  let slNo = 0;

  return (
    <>
      <div className="communication_table">
        <Box maxWidth="true">
          {/* <ExpenceModal
          openExpenseModal={openExpenseModal}
          setopenExpenseModal={setopenExpenseModal}
          ExpencesData={ExpencesData}
          title="Meeting List"
        /> */}
          <ImageView
            title={"Image"}
            imageUrl={ImgUrl}
            open={OpenViewImageModal}
            setOpen={setOpenViewImageModal}
          />
          {/* <div style={{ display: "none" }}>
        <EmpWisTable
          item={clientIdCommunicationDataArray}
          configurationName={configurationName}
          communicationDetailsHeader={clientIdCommunicationDataHeader}
          communicationDetailsDynamiceHeader={
            communicationDetailsDynamiceHeader
          }
        />
      </div> */}
          <Accordion className="main_accoardian" defaultExpanded={true}>
            <AccordionDetails className="accoardian_body">
              <TableContainer
                component={Paper}
                className="top_table_bg"
                style={{ height: "calc(-225px + 100vh)", background: "#fff" }}
              >
                <Table
                  size="small"
                  aria-label="a dense table"
                  // border={0.5}
                  stickyHeader
                  sx={{
                    minWidth: 1200,

                    "& tbody td": {
                      border: "0.5px solid #d0d7de",
                    },

                    // First column
                    "& th:first-of-type, & td:first-of-type": {
                      position: "sticky",
                      left: 0,
                      zIndex: 2,
                      // backgroundColor: "#fff",
                    },

                    "td:first-of-type": {
                      backgroundColor: "#fff",
                    },

                    // Header cells
                    "& thead th": {
                      position: "sticky",
                      top: 0,
                      zIndex: 3,
                      backgroundColor: "rgb(32 80 130)",
                      border: "none",
                    },

                    // Top-left cell needs highest z-index
                    "& thead th:first-of-type": {
                      left: 0,
                      zIndex: 4,
                    },
                  }}
                  //  id="table-to-xls"
                >
                  <TableHead>
                    <TableRow
                      sx={{
                        // background: "rgb(32 80 130)",
                        // color: "#FFF",
                        boxShadow: "0px 6px 0px 10px white",
                        borderRadius: "10px",
                        overflow: "hidden",
                        ".MuiTableCell-root": {
                          backgroundColor: "rgb(32 80 130)",
                          color: "#fff",
                          div: {
                            // width: 170,
                            // whiteSpace: "nowrap",
                            // textOverflow: "ellipsis",
                            // overflow: "hidden",
                            textAlign: "left",
                            width: "max-content",
                            padding: "10px",
                          },
                        },
                      }}
                    >
                      {/* <TableCell style={{ color: "#FFF" }} align="center">
                  Date
                </TableCell>
                {configurationName !== undefined && configurationName === "IS_MEETING_DURATION" && (<>
                  <TableCell style={{ color: "#FFF" }} align="center">
                    Meeting Start Time
                  </TableCell>
                  <TableCell style={{ color: "#FFF" }} align="center">
                    Meeting End Time
                  </TableCell>
                  <TableCell style={{ color: "#FFF" }} align="center">
                    Meeting Start Location
                  </TableCell>
                  <TableCell style={{ color: "#FFF" }} align="center">
                    Meeting End Location
                  </TableCell>
                  <TableCell style={{ color: "#FFF" }} align="center">
                    Meeting Duration
                  </TableCell>
                </>)}

                <TableCell style={{ color: "#FFF" }} align="center">
                  Emp Name(Emp Code)
                </TableCell>
                {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14 ?
                  <TableCell style={{ color: "#FFF" }} align="center">
                    Party Type
                  </TableCell> : ""}
                <TableCell style={{ color: "#FFF" }} align="center">
                  Vendor/Client/Other
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  Client Status
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  {companyToken.toLowerCase().indexOf("paul") == -1
                    ? "Website"
                    : "Investment Amount"}
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  Relationship Type
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  Person Name
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  {companyToken.toLowerCase().indexOf("paul") == -1
                    ? "Contact Number"
                    : "Mobile No"}
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  Meeting Type
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  Discussion Detail
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  {companyToken.toLowerCase().indexOf("paul") == -1
                    ? "Remarks"
                    : "Description"}
                </TableCell>
                {JSON.parse(localStorage.getItem("showHeader")) == true ? (
                  <>
                    <TableCell style={{ color: "#FFF" }} align="center">
                      Distance
                    </TableCell>
                    <TableCell style={{ color: "#FFF" }} align="center">
                      Meeting Distance Fare (₹)
                    </TableCell>
                  </>
                ) : (
                  ""
                )}
                <TableCell style={{ color: "#FFF" }} align="center">
                  Meeting Expense Amount (₹)
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  Total Distance(Kms)
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  Daily Distance Fare (₹)
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  Total Expense (₹)
                </TableCell>
                <TableCell style={{ color: "#FFF" }} align="center">
                  <span style={{ display: "flex" }}>
                    Total Amount(₹){" "}
                    <Tooltip
                      sx={{ color: "#fff", display: "flex" }}
                      title={
                        "Total Amt = Sum(Meeting Expense Amount (₹) + Daily Distance Fare (₹) + Total Expense(₹))"
                      }
                    >
                      <IconButton>
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </span>
                </TableCell>
                <TableCell  style={{ color: "#FFF" }} align="center">
                  Details
                </TableCell> */}
                      {clientIdCommunicationDataHeader &&
                        clientIdCommunicationDataHeader.length > 0 && (
                          <TableCell
                            style={{ color: "#FFF", whiteSpace: "nowrap" }}
                            align="left"
                          >
                            SL No.
                          </TableCell>
                        )}
                      {communicationDetailsDynamiceHeader &&
                        communicationDetailsDynamiceHeader.length > 0 &&
                        communicationDetailsDynamiceHeader.map(
                          (dynamiceHeader) => {
                            return (
                              <>
                                {dynamiceHeader.IsShowWeb === true ? (
                                  <TableCell
                                    style={{ color: "#FFF" }}
                                    align="left"
                                  >
                                    <div>
                                      {dynamiceHeader && dynamiceHeader.label}
                                    </div>
                                  </TableCell>
                                ) : (
                                  ""
                                )}
                              </>
                            );
                          },
                        )}
                      {clientIdCommunicationDataHeader &&
                        clientIdCommunicationDataHeader.length > 0 &&
                        clientIdCommunicationDataHeader.map((header) => {
                          return (
                            <>
                              {header.isShowOnWeb === true && (
                                <>
                                  {header.name === "Total Amount ₹" ? (
                                    <TableCell
                                      style={{ color: "#FFF" }}
                                      align="left"
                                    >
                                      <div style={{ display: "flex" }}>
                                        {header && header.displayName
                                          ? header.displayName
                                          : ""}
                                        <Tooltip
                                          sx={{
                                            color: "#fff",
                                            display: "flex",
                                          }}
                                          title={
                                            "Total Amt = Sum(Meeting Expense Amount + Daily Distance Fare (₹) + Total Expense(₹))"
                                          }
                                        >
                                          <IconButton>
                                            <InfoIcon />
                                          </IconButton>
                                        </Tooltip>
                                      </div>
                                    </TableCell>
                                  ) : header.name === "Odometer Details" ||
                                    header.name === "Odometer Distance" ? (
                                    <>
                                      {localData?.isOdMeterReadingRequiredOnOd ? (
                                        <TableCell
                                          style={{ color: "#FFF", minWidth:"240px" }}
                                          align="left"
                                        >
                                          {header && header.displayName
                                            ? header.displayName
                                            : ""}
                                        </TableCell>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  ) : (
                                    <TableCell
                                      style={{ color: "#FFF" }}
                                      align="left"
                                    >
                                      <Box>
                                        {header && header.displayName
                                          ? header.displayName
                                          : ""}
                                      </Box>
                                    </TableCell>
                                  )}
                                </>
                              )}
                            </>
                          );
                        })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {console.log(
                      clientIdCommunicationDataArray,
                      "arrayyyyyyyy....",
                    )}
                    {clientIdCommunicationDataArray &&
                      clientIdCommunicationDataArray !== undefined &&
                      clientIdCommunicationDataArray.length > 0 &&
                      clientIdCommunicationDataArray.map((item, indexx, a1) => {
                        // let totalemp = [];

                        // totalemp.push(
                        //   item &&
                        //     item.clientCommunicationDtoList &&
                        //     item.clientCommunicationDtoList.length
                        // );
                        // [totalemp] &&
                        //   [totalemp].map((countIndex, index) => {
                        //     const TotalExpenseAmount = countIndex.reduce(
                        //       (accumulator, currentValue) =>
                        //         Number(accumulator ? accumulator : 0) +
                        //         Number(currentValue ? currentValue : 0),
                        //       0
                        //     );

                        // let colorString = "abc";
                        // colorString = moment(new Date(item.createdDate)).format(
                        //   "DD/MM/YYYY HH:mm"
                        // );
                        if (indexx !== 0 && currentColor === colorArray[0]) {
                          currentColor = colorArray[1];
                        } else if (
                          indexx !== 0 &&
                          currentColor === colorArray[1]
                        ) {
                          if (
                            item &&
                            item.clientCommunicationDtoList &&
                            item.clientCommunicationDtoList.length > 0
                          ) {
                            currentColor = colorArray[0];
                          }
                        }
                        let arr1 =
                          clientIdCommunicationData !== undefined &&
                          clientIdCommunicationData.length !== 0
                            ? item.clientCommunicationDtoList.slice(0, 1)
                            : item.clientCommunicationDtoList;
                        console.log("row is rerendering.......");
                        return (
                          <React.Fragment key={item.id}>
                            {item &&
                              item.clientCommunicationDtoList &&
                              arr1.map((curelem, index, arr) => {
                                // const n =
                                //   curelem.conclusion.includes("\n") &&
                                //   curelem.conclusion.replace(/\n/, "");
                                // const copy = curelem.conclusion.slice();
                                // const t = curelem.conclusion.slice(
                                //   0,
                                //   curelem.conclusion.length - 3
                                // );
                                // const isBase64Encdoed = base64regex.test(t + "==");

                                let count;
                                if (index === 0) {
                                  count = 1;
                                } else {
                                  count = 0;
                                }
                                if (index !== 0) {
                                  if (
                                    curelem.createDate ===
                                    item.clientCommunicationDtoList[index - 1]
                                      .createDate
                                  ) {
                                    // no code here
                                  } else {
                                    if (currentColor === colorArray[0]) {
                                      currentColor = colorArray[1];
                                    } else if (currentColor === colorArray[1]) {
                                      currentColor = colorArray[0];
                                    }
                                  }
                                }
                                slNo++;
                                return (
                                  <CustomRow
                                    key={curelem.id}
                                    curelem={curelem}
                                    item={item}
                                    currentColor={currentColor}
                                    slNo={slNo}
                                    count={count}
                                    communicationDetailsDynamiceHeader={
                                      communicationDetailsDynamiceHeader
                                    }
                                    OpenImageDirectTopage={
                                      OpenImageDirectTopage
                                    }
                                    clientIdCommunicationDataHeader={
                                      clientIdCommunicationDataHeader
                                    }
                                    clientIdCommunicationData={
                                      clientIdCommunicationData
                                    }
                                    viewImageRidarect={viewImageRidarect}
                                    openmodalhalndlerBysingle={
                                      openmodalhalndlerBysingle
                                    }
                                    openmodalhalndler={openmodalhalndler}
                                    handleView={handleView}
                                    arr={arr}
                                    localData={localData}
                                    handleViewDefaultMeeting={
                                      handleViewDefaultMeeting
                                    }
                                  />
                                );
                              })}
                          </React.Fragment>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        </Box>
      </div>
      <ViewDefaultMeetingDialog
        open={defaultMeetingModal?.open}
        onClose={handleCloseDefaultMeetingModal}
        meetingData={defaultMeetingModal?.data}
      />
    </>
  );
};

const CustomRow = React.memo(
  ({
    item,
    curelem,
    currentColor,
    slNo,
    count,
    communicationDetailsDynamiceHeader = [],
    OpenImageDirectTopage = () => {},
    clientIdCommunicationDataHeader = [],
    clientIdCommunicationData = [],
    viewImageRidarect = () => {},
    openmodalhalndlerBysingle = () => {},
    openmodalhalndler = () => {},
    handleView = () => {},
    arr = [],
    localData,
    handleViewDefaultMeeting,
  }) => {
    console.log("customrow is renderingggg....... : ", item);
    return (
      <TableRow
        sx={{
          backgroundColor: currentColor,
          padding: 0,
        }}
      >
        {clientIdCommunicationDataHeader &&
          clientIdCommunicationDataHeader.length > 0 && (
            <TableCell>{slNo}</TableCell>
          )}
        {curelem &&
          curelem !== null &&
          curelem !== undefined &&
          [curelem].map((element, index, array) => {
            console.log(item, "curejjjlem");
            return (
              <>
                {communicationDetailsDynamiceHeader &&
                  communicationDetailsDynamiceHeader.length > 0 &&
                  communicationDetailsDynamiceHeader.map((header, ind) => {
                    console.log(header, "header");
                    const headerName = header && header.uid;
                    const jsonDataMap =
                      element.jsonData != null
                        ? Object.fromEntries(
                            element.jsonData &&
                              element.jsonData.map((e) => [e.uid, e.value]),
                          )
                        : null;

                    return (
                      <>
                        {header.IsShowWeb === true ? (
                          <>
                            {header.compName === "image" ||
                            header.compName === "File" ? (
                              <TableCell align="left">
                                {jsonDataMap &&
                                jsonDataMap[headerName] != null &&
                                jsonDataMap[headerName] !== "" ? (
                                  <Tooltip title="Click to view">
                                    <Avatar
                                      onClick={() =>
                                        OpenImageDirectTopage(
                                          jsonDataMap &&
                                            jsonDataMap[headerName] != null
                                            ? jsonDataMap[headerName]
                                            : "",
                                        )
                                      }
                                      alt="Remy Sharp"
                                      src={
                                        jsonDataMap &&
                                        jsonDataMap[headerName] != null
                                          ? jsonDataMap[headerName]
                                          : ""
                                      }
                                    />
                                  </Tooltip>
                                ) : (
                                  "NA"
                                )}
                              </TableCell>
                            ) : header.compName === "TextArea" ? (
                              <TableCell
                                align={
                                  /^\d+$/.test(
                                    (jsonDataMap && jsonDataMap[headerName]) ||
                                      "",
                                  )
                                    ? "right"
                                    : "left"
                                }
                              >
                                {/* {jsonDataMap &&
                                                            jsonDataMap[
                                                              headerName
                                                            ] !==null &&
                                                            jsonDataMap[
                                                              headerName
                                                            ] !== ""
                                                             &&
                                                           
                                                             base64regex.test(jsonDataMap[headerName] && jsonDataMap[headerName] !==null && jsonDataMap[headerName] !==""&&  jsonDataMap[headerName].replace(/\n/,""))
                                                              ? Base64.decode(
                                                                  jsonDataMap &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] != null &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !== "" &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !==
                                                                      undefined
                                                                    ? jsonDataMap[
                                                                        headerName
                                                                      ]
                                                                    : "NA"
                                                                )
                                                              : jsonDataMap &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] != null &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] !== "" &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] !== undefined
                                                              ? jsonDataMap[
                                                                  headerName
                                                                ]
                                                              : "NA"} */}
                                {jsonDataMap &&
                                jsonDataMap[headerName] != null &&
                                jsonDataMap[headerName] !== "" &&
                                jsonDataMap[headerName] !== undefined
                                  ? jsonDataMap[headerName]
                                  : "NA"}
                              </TableCell>
                            ) : header.compName === "Text" ? (
                              <TableCell
                                align={
                                  /^\d+$/.test(
                                    (jsonDataMap && jsonDataMap[headerName]) ||
                                      "",
                                  )
                                    ? "right"
                                    : "left"
                                }
                              >
                                {/* {jsonDataMap &&
                                                            jsonDataMap[
                                                              headerName
                                                            ] !==null &&
                                                            jsonDataMap[
                                                              headerName
                                                            ] !== "" &&
                                                           
                                                            base64regex.test(jsonDataMap[headerName] && jsonDataMap[headerName] !==null && jsonDataMap[headerName] !==""&&  jsonDataMap[headerName].replace(/\n/,""))
                                                              ? Base64.decode(
                                                                  jsonDataMap &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] != null &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !== "" &&
                                                                    jsonDataMap[
                                                                      headerName
                                                                    ] !==
                                                                      undefined
                                                                    ? jsonDataMap[
                                                                        headerName
                                                                      ]
                                                                    : "NA"
                                                                )
                                                              : jsonDataMap &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] != null &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] !== "" &&
                                                                jsonDataMap[
                                                                  headerName
                                                                ] !== undefined
                                                              ? jsonDataMap[
                                                                  headerName
                                                                ]
                                                              : "NA"} */}
                                {jsonDataMap &&
                                jsonDataMap[headerName] != null &&
                                jsonDataMap[headerName] !== "" &&
                                jsonDataMap[headerName] !== undefined
                                  ? jsonDataMap[headerName]
                                  : "NA"}
                              </TableCell>
                            ) : header.compName === "Checkbox" ? (
                              <TableCell
                                align={
                                  /^\d+$/.test(
                                    (jsonDataMap && jsonDataMap[headerName]) ||
                                      "",
                                  )
                                    ? "right"
                                    : "left"
                                }
                              >
                                {jsonDataMap &&
                                jsonDataMap[headerName] != null &&
                                jsonDataMap[headerName] !== "" &&
                                jsonDataMap[headerName] !== undefined
                                  ? jsonDataMap[headerName] == true
                                    ? "Yes"
                                    : "NO"
                                  : "NA"}
                              </TableCell>
                            ) : (
                              <TableCell
                                align={
                                  /^\d+$/.test(
                                    (jsonDataMap && jsonDataMap[headerName]) ||
                                      "",
                                  )
                                    ? "right"
                                    : "left"
                                }
                              >
                                {jsonDataMap &&
                                jsonDataMap[headerName] != null &&
                                jsonDataMap[headerName] !== "" &&
                                jsonDataMap[headerName] !== undefined
                                  ? jsonDataMap[headerName]
                                  : "NA"}
                              </TableCell>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    );
                  })}
              </>
            );
          })}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[0]?.isShowOnWeb === true ? (
          <TableCell sx={{ minWidth: "180px" }} align="left">
            {moment(
              clientIdCommunicationData.length !== 0
                ? clientIdCommunicationData[0].createdDateTime
                : curelem.createdDateTime,
            ).format("DD/MM/YYYY hh:mm A")}
          </TableCell>
        ) : (
          ""
        )}
        {/* {configurationName !== undefined &&
                                    configurationName ===
                                      "IS_MEETING_DURATION" && (
                                      <> */}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[1]?.isShowOnWeb === true ? (
          <TableCell sx={{ minWidth: "180px" }} align="left">
            {curelem && curelem.meetingOnDateTime
              ? moment(curelem.meetingOnDateTime).format("hh:mm A")
              : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[2]?.isShowOnWeb === true ? (
          <TableCell sx={{ minWidth: "180px" }} align="left">
            {curelem && curelem.meetingOffDateTime
              ? moment(curelem.meetingOffDateTime).format("hh:mm A")
              : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[3]?.isShowOnWeb === true ? (
          <TableCell sx={{ minWidth: "180px" }} align="left">
            {curelem && curelem.startAddress ? curelem.startAddress : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[4]?.isShowOnWeb === true ? (
          <TableCell sx={{ minWidth: "180px" }} align="left">
            {curelem && curelem.address ? curelem.address : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[5]?.isShowOnWeb === true ? (
          <TableCell sx={{ minWidth: "180px" }} align="right">
            {curelem && curelem.meetingDuration
              ? curelem.meetingDuration
              : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {/* </>
                                    )} */}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[6]?.isShowOnWeb === true ? (
          <TableCell
            align="left"
            style={{
              minWidth: "160px",
            }}
          >
            <p>
              Start: {" "} 
              {item && item.createdDate
                ? moment(item.createdDate).format("hh:mm A")
                : "NA"}
            </p>
            <p>
              End:{" "}
              {item && item.date ? moment(item.date).format("hh:mm A") : "NA"}
            </p>
            {/* {`${(element.startTime)}  ${(element.endTime)}`} */}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[7]?.isShowOnWeb === true ? (
          <TableCell align="left">
            {clientIdCommunicationData.length !== 0
              ? clientIdCommunicationData[0].clientName
              : curelem.clientName && curelem.clientName !== ""
                ? curelem.clientName
                : "NA"}{" "}
            {curelem?.locationVisitId && (
              <Tooltip
                sx={{ color: "#103a71", display: "flex" }}
                title={"Click to view default meeting details"}
              >
                <IconButton onClick={() => handleViewDefaultMeeting(curelem)}>
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            )}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[8]?.isShowOnWeb === true ? (
          <TableCell align="left">
            {clientIdCommunicationData.length !== 0
              ? clientIdCommunicationData[0].contactPerson
              : curelem.contactPerson && curelem.contactPerson !== ""
                ? curelem.contactPerson
                : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[9]?.isShowOnWeb === true ? (
          <TableCell align="left">
            <Typography variant="body2" style={{ float: "middle" }}>
              {`${
                clientIdCommunicationData.length !== 0
                  ? clientIdCommunicationData[0].userName
                  : item.userName
              } ${item.empCode == null ? "" : `(${item.empCode})`}`}
            </Typography>
          </TableCell>
        ) : (
          ""
        )}
        {/* {JSON.parse(localStorage.getItem("data")).hrmsCompanyId == 14 ?
                                  <> */}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[10]?.isShowOnWeb === true ? (
          <TableCell align="left">
            {curelem &&
            curelem.clientCurrentStatus &&
            curelem.clientCurrentStatus !== null
              ? curelem.clientCurrentStatus.statusName
              : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[11]?.isShowOnWeb === true ? (
          <TableCell>
            {curelem && curelem.clientType && curelem.clientType !== null
              ? curelem.clientType
              : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {/* </> : ""} */}

        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[12]?.isShowOnWeb === true ? (
          <TableCell align="right">
            {clientIdCommunicationData.length !== 0
              ? clientIdCommunicationData[0].contactPersonNo
              : curelem.contactPersonNo && curelem.contactPersonNo !== ""
                ? curelem.contactPersonNo
                : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {/* <TableCell align="center">
                                    {clientIdCommunicationData.length !== 0
                                      ? clientIdCommunicationData[0].website
                                      : curelem.website
                                        ? curelem.website
                                        : "NA"}
                                  </TableCell> */}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[13]?.isShowOnWeb === true ? (
          <TableCell align="left">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <p>
                {clientIdCommunicationData.length !== 0
                  ? clientIdCommunicationData[0].mode
                  : curelem.mode && curelem.mode !== ""
                    ? curelem.mode
                    : "NA"}
              </p>
              <p>
                {curelem.visitingCardUrl &&
                curelem.visitingCardUrl !== null &&
                curelem.visitingCardUrl !== "" ? (
                  <IconButton
                    onClick={() => viewImageRidarect(curelem.visitingCardUrl)}
                  >
                    <InfoIcon />
                  </IconButton>
                ) : (
                  ""
                )}
              </p>
            </div>
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[14]?.isShowOnWeb === true ? (
          <TableCell align="left">
            {clientIdCommunicationData.length !== 0
              ? clientIdCommunicationData[0].reason
              : curelem.reason !== ""
                ? curelem.reason
                : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[15]?.isShowOnWeb === true ? (
          <TableCell align="left">
            {/* {clientIdCommunicationData.length !== 0
                                      ? clientIdCommunicationData[0]
                                        .isNewClient == true
                                        ? "New Client"
                                        : "Existing Client"
                                      : curelem.isNewClient == true
                                        ? "New Client"
                                        : "Existing Client"} */}
            {/* {curelem &&
                                      curelem.conclusion &&
                                      curelem.conclusion !== "" &&
                                      curelem.conclusion.includes("\n") &&
                                      base64regex.test(
                                        curelem.conclusion.replace(/\n/, "")
                                      )
                                        ? Base64.decode(curelem.conclusion)
                                        : curelem.conclusion
                                        ? curelem.conclusion
                                        : "NA"} */}
            {curelem.conclusion ? curelem.conclusion : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[16]?.isShowOnWeb === true ? (
          <TableCell align="left">
            {curelem.remarks && curelem.remarks ? curelem.remarks : "NA"}

            {/* {curelem &&
                                      curelem.remarks &&
                                      curelem.remarks.includes("\n") &&
                                      base64regex.test(
                                        curelem.remarks.replace(/\n/, "")
                                      )
                                        ? Base64.decode(curelem.remarks)
                                        : curelem.remarks
                                        ? curelem.remarks
                                        : "NA"} */}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[17]?.isShowOnWeb === true ? (
          <TableCell
            align="left"
            style={{
              minWidth: "120px",
            }}
          >
            {curelem && curelem.visitPlace !== "" ? curelem.visitPlace : "NA"}
          </TableCell>
        ) : (
          ""
        )}
        {/* {JSON.parse(
                                    localStorage.getItem("showHeader")
                                  ) == true ? (
                                    <> */}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[18]?.isShowOnWeb === true ? (
          <TableCell align="right">
            {curelem.meetingDistance
              ? `${curelem?.meetingDistance}`
              : "0.00"}
          </TableCell>
        ) : (
          ""
        )}
        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[19]?.isShowOnWeb === true ? (
          <TableCell align="right">
            {curelem.distanceFare
              ? `${`${curelem.distanceFare.toFixed(2)}`} `
              : "0.00"}
          </TableCell>
        ) : (
          ""
        )}
        {/* </>
                                  ) : (
                                    ""
                                  )} */}

        {clientIdCommunicationDataHeader &&
        clientIdCommunicationDataHeader[20]?.isShowOnWeb === true ? (
          <TableCell
            align="right"
            style={{
              minWidth: "160px",
            }}
          >
            
            {curelem &&
            curelem.clientTotalExpenseAmount &&
            curelem.clientTotalExpenseAmount !== null ? (
              <IconButton onClick={() => openmodalhalndlerBysingle(curelem)}>
                <InfoIcon />
              </IconButton>
            ) : (
              ""
            )}
            {curelem.clientTotalExpenseAmount
              ? `${`${curelem.clientTotalExpenseAmount.toFixed(2)}`}`
              : "0.00"}
          </TableCell>
        ) : (
          ""
        )}
        {count === 1 && (
          <>
            {clientIdCommunicationDataHeader &&
            clientIdCommunicationDataHeader[21]?.isShowOnWeb === true ? (
              <TableCell
                // sx={{
                //   borderLeft: "1px solid rgba(224, 224, 224, 1)",
                //   borderRight: "1px solid rgba(224, 224, 224, 1)",
                // }}
                rowSpan={arr.length}
                align="right"
              >
                {`${
                  item.totalDistance && item.totalDistance
                    ? item.totalDistance.toFixed(2)
                    : "0.00 "
                }`}
              </TableCell>
            ) : (
              ""
            )}
          </>
        )}
        {count === 1 && (
          <>
            {clientIdCommunicationDataHeader &&
            clientIdCommunicationDataHeader[22]?.isShowOnWeb === true ? (
              <TableCell
                // sx={{
                //   borderLeft: "1px solid rgba(224, 224, 224, 1)",
                // }}
                align="right"
                rowSpan={arr.length}
              >
                {`${
                  item.totalAmountForOd && item.totalAmountForOd
                    ? item.totalAmountForOd.toFixed(2)
                    : "0.00 "
                }`}
              </TableCell>
            ) : (
              ""
            )}
          </>
        )}
        {count === 1 && (
          <>
            {clientIdCommunicationDataHeader &&
            clientIdCommunicationDataHeader[23]?.isShowOnWeb === true ? (
              <TableCell
                sx={{
                  // borderLeft: "1px solid rgba(224, 224, 224, 1)",
                  minWidth: "120px",
                }}
                align="right"
                rowSpan={arr.length}
              >
                {item.odExpenseAmount
                  ? `${item.odExpenseAmount.toFixed(2)}`
                  : "0.00"}

                {/* <IconButton
                                        onClick={() =>
                                          openmodalhalndler(
                                            curelem.userExpenseDtoList
                                          )
                                        }
                                      >
                                        <InfoIcon />
                                      </IconButton> */}
              </TableCell>
            ) : (
              ""
            )}
          </>
        )}
        {count === 1 && (
          <>
            {clientIdCommunicationDataHeader &&
            clientIdCommunicationDataHeader[24]?.isShowOnWeb === true ? (
              <TableCell
                sx={{
                  paddingLeft: 1,
                  // borderLeft: "1px solid rgba(224, 224, 224, 1)",
                  minWidth: "170px",
                }}
                rowSpan={arr.length}
                //align="center"
              >
                {/* {`${
                                        item.totalAmountForOd &&
                                        item.totalAmountForOd
                                          ? Math.floor(item.totalAmountForOd)
                                          : "NA "
                                      }(₹)`} */}

                <p
                  style={{
                    color: "green",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  onClick={() => openmodalhalndler("APPROVED", item)}
                >
                  <span>Approved:</span>
                  <span>
                    {item.totalApprovedExpenseAndFareAmount
                      ? `${item.totalApprovedExpenseAndFareAmount.toFixed(2)}`
                      : "0.00"}
                  </span>
                </p>
                <p
                  style={{
                    color: "red",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  onClick={() => openmodalhalndler("REJECTED", item)}
                >
                  <span>Rejected:</span>
                  <span>
                    {item.totalRejectedExpenseAndFareAmount
                      ? `${item.totalRejectedExpenseAndFareAmount.toFixed(2)}`
                      : "0.00"}
                  </span>
                </p>
                <p
                  style={{
                    color: "#a9a92f",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  onClick={() => openmodalhalndler("PENDING", item)}
                >
                  <span>Pending:</span>
                  <span>
                    {item.totalPendingExpenseAndFareAmount
                      ? `${item.totalPendingExpenseAndFareAmount.toFixed(2)}`
                      : "0.00"}
                  </span>
                </p>
                <p
                  style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
                  onClick={() => openmodalhalndler("Total", item)}
                >
                  <span>Total:</span>
                  <span>
                    {item.totalExpenseAndFareAmount
                      ? `${item.totalExpenseAndFareAmount.toFixed(2)}`
                      : "0.00"}
                  </span>
                </p>
                {/* <IconButton
                                        onClick={() => openmodalhalndler(item)}
                                      >
                                        <InfoIcon />
                                      </IconButton> */}
              </TableCell>
            ) : (
              ""
            )}
          </>
        )}

        {localData?.isOdMeterReadingRequiredOnOd && count === 1 && (
          <>
            {clientIdCommunicationDataHeader &&
            clientIdCommunicationDataHeader[25]?.isShowOnWeb === true ? (
              <TableCell
                sx={{
                  paddingLeft: 1,
                  // borderLeft: "1px solid rgba(224, 224, 224, 1)",
                  minWidth: "170px",
                }}
                rowSpan={arr.length}
                //align="center"
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      color: "green",
                    }}
                  >
                    Start:
                    {item.odoMeterStartReading
                      ? `${item.odoMeterStartReading.toFixed(2)}`
                      : "NA"}
                  </p>
                  <IconButton
                    onClick={() =>
                      viewImageRidarect(item?.odoMeterStartImageUrl)
                    }
                  >
                    <InfoIcon sx={{ fontSize: "20px" }} />
                  </IconButton>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      color: "green",
                    }}
                  >
                    End:
                    {item.odoMeterEndReading
                      ? `${item.odoMeterEndReading.toFixed(2)}`
                      : "NA"}
                  </p>
                  <IconButton
                    onClick={() => viewImageRidarect(item?.odoMeterEndImageUrl)}
                  >
                    <InfoIcon sx={{ fontSize: "20px" }} />
                  </IconButton>
                </div>
              </TableCell>
            ) : (
              ""
            )}
          </>
        )}

        {localData?.isOdMeterReadingRequiredOnOd && count === 1 && (
          <>
            {clientIdCommunicationDataHeader &&
            clientIdCommunicationDataHeader[26]?.isShowOnWeb === true ? (
              <TableCell
                sx={{
                  paddingLeft: 1,
                  // borderLeft: "1px solid rgba(224, 224, 224, 1)",
                  minWidth: "170px",
                }}
                rowSpan={arr.length}
                //align="center"
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      marginTop: "10px",
                      // cursor: "pointer",
                    }}
                    // onClick={() => openmodalhalndler("APPROVED", item)}
                  >
                    Distance:
                    {item.odoMeterDistanceDifference
                      ? `${item.odoMeterDistanceDifference.toFixed(2)}`
                      : "NA"}
                  </p>
                </div>
              </TableCell>
            ) : (
              ""
            )}
          </>
        )}

        {count === 1 && (
          <>
            {clientIdCommunicationDataHeader &&
            clientIdCommunicationDataHeader[27]?.isShowOnWeb === true ? (
              <TableCell
                sx={
                  {
                    // borderLeft: "1px solid rgba(224, 224, 224, 1)",
                    // borderRight: "1px solid rgba(224, 224, 224, 1)",
                  }
                }
                align="left"
                rowSpan={arr && arr.length}
              >
                <Button
                  onClick={() =>
                    handleView(
                      curelem.usersId,
                      curelem.createdDateTime,
                      item?.id,
                    )
                  }
                  style={{ color: "#23b0a9" }}
                >
                  <img src={eyeIcon} />
                  {/* View */}
                </Button>
              </TableCell>
            ) : (
              ""
            )}
          </>
        )}
        {/* meeting skip details icon */}
        {count === 1 && (
          <>
            {clientIdCommunicationDataHeader &&
            clientIdCommunicationDataHeader[28]?.isShowOnWeb === true ? (
              <TableCell
                sx={
                  {
                    // borderLeft: "1px solid rgba(224, 224, 224, 1)",
                    // borderRight: "1px solid rgba(224, 224, 224, 1)",
                  }
                }
                align="left"
                rowSpan={arr && arr.length}
              >
                <CustomUserModal
                  title={clientIdCommunicationDataHeader[28].displayName}
                  item={item}
                />
              </TableCell>
            ) : (
              ""
            )}
          </>
        )}
      </TableRow>
    );
  },
);

export function CustomUserModal({ title, item }) {
  return (
    <UseModal button={"icon"} title={title} width={"65%"}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow
              style={{
                backgroundColor: "rgb(32 80 130)",
                color: "#fff",
              }}
              key={1}
            >
              <TableCell style={{ color: "#fff" }} align="left">
                S.No
              </TableCell>
              <TableCell style={{ color: "#fff" }} align="left">
                Skipped Times
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {item?.missingLocationTime?.map((missingTime, missingIndex) => {
              return (
                <TableRow key={v4()}>
                  <TableCell align="left">{missingIndex + 1}</TableCell>
                  <TableCell align="left">
                    {`${missingTime.startTime} - ${missingTime.endTime}`}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </UseModal>
  );
}

export default React.memo(SummaryReport);
